module.exports = __webpack_public_path__ + "img/trial1-4.347c3e41.png";